import { Component, Inject, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import DsModal from '@/shared/modal/ds-modal.vue';
import WebsocketService from '@/service/websocket.service';
import ScrapAgentService from '@/service/scrap-agent.service';
import { Account } from '@/shared/model/scrap-agent.model';

interface AppInfo {
  redirectUrl: string;
  clientId: string;
  scope: string;
  appId: number;
  clientSecret: string;
}

@Component({
  components: { DsModal },
})
export default class ScrapAgentAccountLoginMailComponent extends Vue {
  @Prop({ type: Boolean, required: true }) open!: boolean;
  @Prop({ type: String, required: true }) typeEmail!: string;
  @PropSync('channelConnect', { type: Object }) syncedChannelConnect!: any;
  @Inject('websocketService')
  private websocketService: () => WebsocketService;
  @Inject('scrapAgentService')
  public scrapAgentService: () => ScrapAgentService;

  showModal = this.open;
  mailSrc = '';
  nameMail = '';
  appInfo: AppInfo | null = null;
  messageProcessed = false;
  authState: string;
  redirectUrl: string = window.location.origin + '/api/public/goAuth';

  @Watch('open')
  onOpenChange(value: boolean) {
    this.showModal = value;
    window.removeEventListener('message', this.receiveMessage);
    window.addEventListener('message', this.receiveMessage, false);
    if (value) {
      this.scrapAgentService()
        .getAppInfo(this.syncedChannelConnect.channelType)
        .then((result: any) => {
          if (result && result.body && result.body.length > 0) {
            this.appInfo = {
              appId: result.body[0].appId,
              redirectUrl: result.body[0].redirectUrl,
              clientId: result.body[0].clientId,
              scope: result.body[0].scope,
              clientSecret: result.body[0].clientSecret,
            };
            console.log('Fetched appInfo:', this.appInfo);
          }
        })
        .catch(error => {
          console.error('Failed to fetch app info:', error);
        });
    }
  }

  beforeDestroy() {
    window.removeEventListener('message', this.receiveMessage);
  }

  @Watch('typeEmail', { immediate: true })
  onTypeEmailChange(newType: string) {
    const channelNameMap: Record<string, string> = {
      GMAIL: 'Gmail',
      YAHOO: 'Yahoo',
      OUTLOOK: 'Outlook',
      NAVER: 'Naver',
      DAUM: 'Daum',
    };
    this.nameMail = channelNameMap[newType];
    switch (newType) {
      case 'GMAIL':
        this.mailSrc = 'https://dzh91b51qfr7r.cloudfront.net/social-channel-thumb/gmail.png';
        break;
      case 'OUTLOOK':
        this.mailSrc = 'https://dzh91b51qfr7r.cloudfront.net/social-channel-thumb/outlook.png';
        break;
      case 'YAHOO':
        this.mailSrc = 'https://dzh91b51qfr7r.cloudfront.net/social-channel-thumb/yahoo.png';
        break;
      default:
        this.mailSrc = '';
    }
  }

  handleCloseMail() {
    this.$emit('modal:close');
    this.messageProcessed = false;
  }

  openPopup() {
    if (this.typeEmail == 'GMAIL') {
      this.openGooglePopup().then(r => {});
    } else if (this.typeEmail == 'OUTLOOK') {
      this.openMicrosoftLogin();
    } else if (this.typeEmail == 'YAHOO') {
      this.openYahooPopup();
    }
  }

  openYahooPopup() {
    // const clientId = 'dj0yJmk9U3JZOXZydld3bmk1JmQ9WVdrOVdETTVZakJZTlhrbWNHbzlNQT09JnM9Y29uc3VtZXJzZWNyZXQmc3Y9MCZ4PTkw';
    // const redirectUri = encodeURIComponent('https://goover.ai/api/public/goAuth');
    // const scope = encodeURIComponent('openid profile email');
    const nonce = encodeURIComponent('fd65b649-aedd-4b02-a3dc-304ddf095013');
    const clientId = this.appInfo.clientId;
    this.authState = this.generateWindowId();
    const redirectUri = encodeURIComponent(`${this.redirectUrl}`);
    const scope = encodeURIComponent(this.appInfo.scope);

    const authUrl =
      `https://api.login.yahoo.com/oauth2/request_auth` +
      `?client_id=${clientId}` +
      `&response_type=code` +
      `&redirect_uri=${redirectUri}` +
      `&scope=${scope}` +
      `&state=${this.authState}` +
      `&nonce=${nonce}`;
    const popup = window.open(authUrl, 'Yahoo Login', 'width=600,height=600');
    // const checkPopup = setTimeout(() => {
    //   if (!popup || popup.closed) {
    //     clearInterval(checkPopup);
    //     console.log('Popup close, cannot get code.');
    //     return;
    //   }
    // }, 500);
  }

  openMicrosoftLogin() {
    const clientId = this.appInfo.clientId;
    this.authState = this.generateWindowId();
    const redirectUri = encodeURIComponent(`${this.redirectUrl}`);
    const scope = encodeURIComponent(this.appInfo.scope);
    // const scope = encodeURIComponent('Mail.Read Mail.ReadWrite offline_access');

    // const userId = JSON.parse(localStorage.getItem('localStorageUser'))?.id || '';
    // const redirectUri = encodeURIComponent(``);
    // const scope = encodeURIComponent('User.Read Mail.Read Mail.ReadWrite offline_access');
    // const state = encodeURIComponent(userId);
    const authUrl =
      `https://login.microsoftonline.com/common/oauth2/v2.0/authorize` +
      `?response_type=code` +
      `&client_id=${clientId}` +
      `&redirect_uri=${this.redirectUrl}` +
      `&response_mode=query` +
      `&scope=${scope}` +
      `&state=${this.authState}`;

    const popup = window.open(authUrl, 'Microsoft Login', 'width=600,height=600');
    if (!popup) {
      return;
    }
    // const checkPopup = setTimeout(() => {
    //   if (!popup || popup.closed) {
    //     clearInterval(checkPopup);
    //     console.log('Popup close, cannot get code.');
    //     return;
    //   }
    // }, 500);
  }

  async openGooglePopup() {
    console.log(this.appInfo, 'GmailApp');
    // const clientId = '282196142246-bmgl02ms6oohg6r2rslsvuui721se15e.apps.googleusercontent.com';
    // const redirectUri = encodeURIComponent('http://localhost:9000/api/public/goAuth'); // Đổi sang localhost
    // const scope = encodeURIComponent('https://www.googleapis.com/auth/youtube');
    // const accessType = 'offline';
    // const state = JSON.parse(localStorage.getItem('localStorageUser'))?.id || '';
    // const redirectUri = encodeURIComponent(`${baseUrl}/api/public/goAuth`);
    // const redirectUri = encodeURIComponent(`https://goover.ai/api/public/goAuth`);
    const responseType = 'code';
    this.authState = this.generateWindowId();
    const clientId = this.appInfo.clientId;
    const redirectUri = encodeURIComponent(`${this.redirectUrl}`);
    const scope = encodeURIComponent(this.appInfo.scope);
    // const state = 'state_parameter_passthrough_value';

    const authUrl =
      `https://accounts.google.com/o/oauth2/v2/auth` +
      `?access_type=offline` +
      `&client_id=${clientId}` +
      `&response_type=${responseType}` +
      `&redirect_uri=${this.redirectUrl}` +
      `&scope=${this.appInfo.scope}` +
      `&state=${this.authState}` +
      `&prompt=consent`;
    //      `&auth_state=${this.authState}`+

    const popup = window.open(authUrl, 'Gmail', 'width=600,height=600');
    // const timer = setInterval(() => {
    //   if (popup && popup.closed) {
    //     clearInterval(timer);
    //     console.log('Google auth popup closed.');
    //   }
    // }, 500);
  }

  receiveMessage(event: MessageEvent) {
    if (this.messageProcessed) {
      return;
    }
    console.log(event.data, 'event.data');
    console.log(this.authState, 'authState');
    // Verify that the message payload contains the expected state and authorization_code.
    if (event.data && event.data.authorization_code && event.data.state === this.authState) {
      this.messageProcessed = true;
      const authCode = event.data.authorization_code;
      this.handleAccountConnect(authCode).then(r => {});
    } else {
      this.messageProcessed = false;
      console.warn('Ignoring unexpected message payload:', event.data);
    }
  }

  async handleAccountConnect(authorizationCode: string) {
    console.log('Received matching authorization code:', authorizationCode);
    const payload = {
      userKey: JSON.parse(localStorage.getItem('localStorageUser') || '{}')?.id || null,
      chanelName: this.syncedChannelConnect.channelType,
      avatar: this.mailSrc,
      clientId: this.appInfo.clientId,
      authorizationCode: authorizationCode,
      appId: this.appInfo.appId,
      clientSecret: this.appInfo.clientSecret,
      redirectUrl: this.redirectUrl,
      scope: this.appInfo.scope,
    };
    try {
      const result = await this.scrapAgentService().addUserAccount(payload);
      const responseBody = result?.data?.body?.body?.body;
      // if (!responseBody?.isSuccess) {
      //   alert('Authorization failed. Please try again.');
      //   return;
      // }
      if (!this.syncedChannelConnect.accounts) {
        this.syncedChannelConnect.accounts = [];
      }
      if (result) {
        this.$bvToast.toast(`${this.$t('scrap-agent.toast.add-account.messAuSuccess')}`, {
          toaster: 'b-toaster-bottom-right',
          title: `${this.$t('scrap-agent.toast.add-account.titleAuSuccess')}`,
          variant: 'success',
          solid: true,
          autoHideDelay: 5000,
        });
      }
      this.messageProcessed = false;
      this.$emit('modal:close', responseBody.accountId);
    } catch (error) {
      console.error('error: ', error);
      this.$bvToast.toast(`${this.$t('scrap-agent.toast.add-account.messFail')}`, {
        toaster: 'b-toaster-bottom-right',
        title: `${this.$t('scrap-agent.toast.add-account.titleAuFail')}`,
        variant: 'danger',
        solid: true,
        autoHideDelay: 5000,
      });
    }
  }

  generateWindowId(): string {
    return 'id_' + Math.random().toString(36).substr(2, 9);
  }
}
